


















import {Component, Vue} from 'vue-property-decorator';
import PageWithSidebar from '@/components/Views/Home Page/PageWithSidebar.vue';
import Footer from '@/components/Views/Home Page/Footer.vue';
import FooterLinks from '@/components/Views/Home Page/FooterLinks.vue';

@Component({
    components: {FooterLinks, Footer, PageWithSidebar},
})
export default class FAQ extends Vue {
    private faqs = [
        {
            question: 'How does SoPlush Beauty Work?',
            answer: 'Choose your city, desired service and appointment date and time. Then your stylist(s) arrives at your home, office or hotel with everything needed to create your perfect look!',
        },
        {
            question: 'What is Required to Book?',
            answer: 'Just let us know the time, place and service(s) you are interested in. We accept all major credit cards and payment is due at time of booking.',
        },
        {
            question: 'How Far In Advance Should I Book My Appointment?',
            answer: 'It is recommended to book as soon as your date is confirmed to ensure availability.',
        },
        {
            question: 'How Should I Prepare For My Appointment?',
            answer: '<b>Makeup</b>: Please make sure your face is completely clean and free of any product when your artists arrive. <br/><br/> <b>Hair</b>: If your appointment is for a blowout, make sure your hair is washed and damp when your stylist arrives. If your appointment is for a dry style, have your hair washed and dry. We recommend washing your hair the day before for best results.',
        },
        {question: 'How Long Is The Appointment?', answer: 'Typically it takes about 45-60 minutes per person.'},
        {
            question: 'What Is A Trial & Is It Necessary?',
            answer: 'Hair & Makeup trials are an important part of achieving your desired look for your wedding day. This is a time for you to meet your artists, define your style, and begin to envision what you will look like on your special day. <br/><br/> Bring photo ideas so your stylist can make your vision a reality! Have no idea what you want? That’s fine too! Our talented team is here to help you every step of the way!',
        },
        {
            question: 'Will I Have The Same Stylist On My Wedding Day As I Did For My Trial?',
            answer: 'It is <b>highly recommended</b> that you book both the trial and wedding at the same time, because there is no guarantee that the artist will be available for your wedding if booked separately.',
        },
        {
            question: 'How Many Stylists Will Be Arriving For My Appointment?',
            answer: 'Depending on the services booked, there will be one hair and one makeup artist arriving. <br/><br/> With larger groups or time restraints we will accommodate with more stylists.',
        },
        {
            question: 'What Are Your Hours Of Operation?',
            answer: 'As early as 5 am to 11 pm For booking requests outside of normal business hours. <br/><br/> Please <a href = \'mailto: bookings@soplushbeauty.com\'><b>contact us</b></a> directly so we can coordinate the time that best suits you!',
        },
        {
            question: 'What Kind Of Products Do Soplush Pros Use?',
            answer: 'All of our stylist use professional grade products. If you have an allergy or other concerns, please don’t hesitate to <a href = \'mailto: bookings@soplushbeauty.com\'><b>get in touch with us</b></a> so we can make sure you’re booking goes exactly as planned.',
        },
        {
            question: 'What Is Your Cancellation Policy?',
            answer: 'We understand that things may come up. If you cancel 3 or more days before your appointment, the remaining balance will not be charged. <br/><br/> If you cancel within 48 hours or less, you will be charged the full remaining balance.',
        },
        {
            question: 'What Is The Difference Between Plush And SoPlush Pro Stylists?',
            answer: '<b>SoPlush Pros</b> have extensive experience with celebrities and high profile clients. <br/><br/> They would be perfect for Red carpet events, Print, film, weddings and much more. <br/><br/> You can view them as being Master Stylists that have extensive experience with high profile clients. <b>Plush Pros</b> are experts that have been in the industry for multiple years and are highly skilled. They would be perfect for proms, date nights, birthday parties, work events and practically any other event you’d like to achieve a desired look for. <br/><br/> <i><b>Our stylists from each tier are licensed & trained to maintain high standards for sanitation & professionalism to ensure the best possible experience</b></i>',
        },
    ];
}
